import FormDefinition from 'src/app/models/form-definition/form-definition';
import FormDocumentValue from './form-document-value';
import { FormDocumentIdentifier } from './form-document-identifier';
import { SyncStatus } from 'src/app/entities/SyncStatus';

export enum FormDocumentStatus {
  New = 'New',
  InProgress = 'In Progress',
  Submitted = 'Submitted',
}

export default class FormDocument {
  RecordId?: number;
  ID?: number;
  DocumentId?: string;
  CreatedDate: string;
  ModifiedDate?: string;
  SyncedAt?: string;
  FormDefinitionBaseId: number;
  FormVersion: number;
  FormDefinition: FormDefinition;
  FormComponents: FormDocumentValue[];
  Status: FormDocumentStatus;
  ActiveStepIndex: number;
  /** True once any artifact (QR code or print) has been generated for this document, preventing further modifications. */
  artifactGenerated: boolean;
  syncStatus: SyncStatus;
  Identifiers: FormDocumentIdentifier[];
}
